(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.status.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.status.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const DrawCardStatus = _ref => {
  let children = _ref.children,
    _ref$isCancelled = _ref.isCancelled,
    isCancelled = _ref$isCancelled === void 0 ? false : _ref$isCancelled,
    _ref$isLive = _ref.isLive,
    isLive = _ref$isLive === void 0 ? false : _ref$isLive,
    hasHiddenAria = _ref.hasHiddenAria;
  const blockName = 'pg_draw_card__status';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--live")]: isLive,
    ["".concat(blockName, "--cancelled")]: isCancelled
  }, 'pg_draw_card_component');
  return React.createElement("div", {
    "aria-hidden": Boolean(hasHiddenAria),
    className: classNames
  }, children);
};
setGlobal('svs.components.tipsen.drawCardComponents.DrawCardStatus', DrawCardStatus);

 })(window);